import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { AzureMLLinkedService } from 'app/model/linkedservice/azure-ml.linkedservice';
import { format } from 'app/shared/utils/string.util';

export const azureMLMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(AzureMLLinkedService).name,
    displayName: stringResources.AzureML_DisplayText,
    icon: {
        className: 'svg-i-100x100-azure_mlstudio'
    },
    isCompute: true,
    isFirstClass: true,
    category: ['Compute'],
    controls: [
        {
            type: 'textbox',
            bind: 'mlEndpoint',
            label: stringResources.ModelName_Endpoint,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'apiKey',
            label: stringResources.ModelName_APIKey,
            child: {
                type: 'password',
                label: stringResources.ModelName_APIKey,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureML_DisplayText),
                stringResources.ModelName_APIKey)
        },
        {
            type: 'radio-switch',
            nested: 1,
            bind: 'enableUpdateResourceEndpoint',
            isLabelVertical: true,
            options: [
                {
                    label: stringResources.ModelName_AzureMLEnableUpdateResourceEndPoint,
                    value: true
                },
                {
                    label: stringResources.ModelName_AzureMLDisableUpdateResourceEndPoint,
                    value: false
                }
            ],
            defaultValue: '{updateResourceEndpoint != null}',
            cases: [
                {
                    caseValue: true,
                    children: [
                        {
                            type: 'textbox',
                            bind: 'updateResourceEndpoint',
                            label: stringResources.ModelName_AzureMLUpdateResourceEndPoint,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {
                            type: 'radio-switch',
                            nested: 2,
                            bind: 'useARMWebService',
                            isLabelVertical: true,
                            options: [
                                {
                                    label: stringResources.ModelName_AzureMLUseARMWebService,
                                    value: true
                                },
                                {
                                    label: stringResources.ModelName_AzureMLUseClassicalWebService,
                                    value: false
                                }
                            ],
                            defaultValue: false,
                            cases: [
                                {
                                    caseValue: true,
                                    children: [
                                        {
                                            type: 'textbox',
                                            bind: 'servicePrincipalId',
                                            label: stringResources.ModelName_ServicePrincipalID,
                                            required: true,
                                            validators: [
                                                { type: 'required', errorMessage: '' }
                                            ],
                                            isLabelVertical: true,
                                            description: '<a target="_blank" href="https://docs.microsoft.com/azure/data-factory/connector-azure-data-lake-store#using-service-principal-authentication">' +  stringResources.LearnMore + '</a>',
                                            escapeDescription: false
                                        },
                                        {
                                            type: 'dynamic-akv-switcher',
                                            bind: 'servicePrincipalKey',
                                            label: stringResources.ModelName_ServicePrincipalKey,
                                            child: {
                                                type: 'password',
                                                label: stringResources.ModelName_ServicePrincipalKey,
                                                required: true,
                                                isLabelVertical: true
                                            },
                                            validators: [
                                                { type: 'required', errorMessage: '' }
                                            ],
                                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureML_DisplayText),
                                                stringResources.ModelName_ServicePrincipalKey)
                                        },
                                        {
                                            type: 'tenant-textbox',
                                            bind: 'tenant',
                                            validators: [
                                                { type: 'required', errorMessage: '' }
                                            ],
                                            isLabelVertical: true,
                                            label: stringResources.ModelName_Tenant,
                                            required: true
                                        }]
                                }]
                        }]
                }]
        }
    ],
    copySinkTypes: [],
    copySourceTypes: []
};
